var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCloseS2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#svg-public/img/icons/close_s__2.svg__clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4 4L12 12",
  stroke: "#BFC1C7",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 4L4 12",
  stroke: "#BFC1C7",
  strokeWidth: 2,
  strokeLinecap: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "svg-public/img/icons/close_s__2.svg__clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})))));
export { SvgCloseS2 as ReactComponent };